import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { clsx } from 'clsx';
import { type ReactNode } from 'react';

interface EntityDisclosureProps {
  /** Disclosure content */
  children: ReactNode;
  /** Button label (default: "View Details") */
  label?: string;
  /** Indentation level for button */
  indent?: number;
}

/**
 * Collapsible disclosure section for entity details
 */
export const EntityDisclosure = ({
  children,
  label = 'View Details',
  indent = 1,
}: EntityDisclosureProps) => (
  <Disclosure as="div" className="mt-3">
    {({ open }) => (
      <>
        <Disclosure.Button
          className={clsx(
            'flex items-center gap-1.5 text-sm font-medium text-gray-700 hover:text-gray-900',
            indent === 1 && 'ml-7',
          )}
        >
          <span>{label}</span>
          <ChevronDownIcon
            className={clsx(
              'h-4 w-4 transition-transform',
              open && 'rotate-180',
            )}
          />
        </Disclosure.Button>

        <Disclosure.Panel
          className={clsx('mt-3 space-y-3', indent === 1 && 'ml-7')}
        >
          {children}
        </Disclosure.Panel>
      </>
    )}
  </Disclosure>
);
